import { createTheme } from "@mui/material/styles";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#0473ea",
//     },
//     secondary: {
//       main: "#38d200",
//     },
//     background: {
//       main: "#ffffff",
//     }
//   },
//   typography: {
//     fontFamily: "Arial, sans-serif",
//     fontSize: 14,
//   },
// });

const theme = createTheme({
  palette: {
    primary: {
      main: "#0473ea",
    },
    secondary: {
      main: "#38d200",
    },
    background: {
      main: "#ffffff",
    }
  },
  typography: {
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
  },
});

export default theme;
